module.exports = __webpack_public_path__ + "img/课堂教学.ec77c7ee.svg";